import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Spinner } from '@lionstep/ui';

import styles from './spinnerFullUI.module.scss';

const SpinnerFullUI = ({
  absolute = false,
  className = '',
  withNavigation = false,
  ...restProps
}) => (
  <Spinner
    position={absolute ? 'absolute' : 'fixed'}
    className={classnames(styles.spinner, className, {
      [styles.withNavigation]: withNavigation,
    })}
    size={200}
    {...restProps}
  />
);

SpinnerFullUI.propTypes = {
  absolute: PropTypes.bool,
  className: PropTypes.string,
  withNavigation: PropTypes.bool,
};

export default SpinnerFullUI;
